module.exports = __webpack_public_path__ + "static/media/ub-pil-90-orange-rgb.0e70a4cd.svg";